<template>
    <div class="items-search-and-select">
        <div class="items-search-and-select__add-new-button mb-5">
            <CoreLinkSecondary
                class="mb-3"
                text="§ui_button.create_new"
                :disabled="!hasPermission('create equipment type')"
                @click="handleOpenModal"
            />
        </div>

        <hr class="mb-5" />

        <div class="items-search-and-select__search mb-5">
            <CoreStringInput
                v-model="filter"
                :fullWidth="true"
                :placeholder="searchPlaceholder"
                ref="searchInput"
                icon="pi-search"
            />
        </div>

        <div class="items-search-and-select__list">
            <div
                class="items-search-and-select__list-header mb-5"
                :class="headerColumnClass"
            >
                <span class="font-bold text-400">{{ $t('§caf.name') }}</span>
                <span
                    v-for="col in columns"
                    :key="col.field"
                    class="font-bold text-400"
                >
                    {{ $t(col.label) }}
                </span>
            </div>

            <div v-if="list === null">LOADING</div>

            <div v-else>
                <ItemRow
                    v-for="item in filteredList"
                    :key="item.id"
                    v-model="selected"
                    :item="item"
                    :radioGroupName="radioGroupName"
                    :columns="columns"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { useModalStore } from '@/stores/modal'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreLinkSecondary from '@/components/core/CoreLinkSecondary.vue'
import ItemRow from './ItemRow.vue'

export default {
    name: 'ItemsSearchAndSelect',

    components: { ItemRow, CoreStringInput, CoreLinkSecondary },

    props: {
        modelValue: {
            type: [String, Number],
            default: null,
        },

        list: {
            required: true,
            validator(value) {
                if (value === null || Array.isArray(value)) return true
                return false
            },
        },

        radioGroupName: {
            type: String,
            required: true,
        },

        inputName: {
            type: String,
            required: true,
        },

        itemCreateModalName: {
            type: String,
            required: true,
        },

        itemCreateModalTitle: {
            type: String,
            required: true,
        },

        searchPlaceholder: {
            required: true,
            type: String,
        },

        columns: {
            type: Array,
            default: () => [
                {
                    label: '§eq_type.model_year',
                    field: 'model_year',
                    fallback: '§eq_type.model_year_not_set',
                },
            ],
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            filter: '',
            modalStore: useModalStore(),
        }
    },

    computed: {
        filteredList() {
            return this.list.filter((item) =>
                item.name.toLowerCase().includes(this.filter.toLowerCase())
            )
        },

        selected: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            },
        },

        headerColumnClass() {
            return `items-search-and-select__list-header--cols-${this.columns.length + 1}`
        },
    },

    mounted() {
        setTimeout(() => {
            this.$refs.searchInput?.focus()
        }, 800)
    },

    methods: {
        handleOpenModal() {
            this.modalStore.setClose()

            this.modalStore.setOpen({
                name: this.itemCreateModalName,
                title: this.itemCreateModalTitle,
                size: 'large',
            })
        },
    },
}
</script>

<style scoped>
.items-search-and-select {
    & .items-search-and-select__list-header {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
    }

    & .items-search-and-select__list-header--cols-2 > span {
        flex: 1 1 50%;
    }

    & .items-search-and-select__list-header--cols-3 > span {
        flex: 1 1 33%;
    }

    & .items-search-and-select__list {
        height: 34rem;
        overflow: auto;
        padding: 0.5rem;
    }
}
</style>
